<div layout="col" layoutAlign="" layoutGap="2">
    <h1>Reset Password</h1>
    <span style="font-size: 14px; color: var(--p-neutral-500);">
        {{"Enter the email associated with your account and we\'ll send an email with instructions to reset your password."| translate}}
    </span>

    <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="wrapper">
            <p-floatlabel variant="on" [style]="{'width': '100%', 'margin-bottom': '16px', 'margin-top': '16px'}">
                <input id="email" formControlName="email" pInputText style="width: 100%;" />
                <label for="email">{{'Email' | translate}}</label>
            </p-floatlabel>
        </div>
    </form>

    <p-button [label]="'Send instructions' | translate" [style]="{'width': '100%'}" fluid
        (click)="submit()"></p-button>
    <div layout="row" layoutAlign="center center">
        <p-button [label]="'Back to Login' | translate" (click)="navigateToLogin()" link></p-button>
    </div>

</div>
